import React from 'react';

import Composer from './Composer';

const MultiComposer = props => <Composer {...props} />;

export default MultiComposer;
